export default __webpack_public_path__ + "static/media/hm-pg-img.2d0f588d.webp";